import React, { useReducer, useMemo } from "react";
import { PluginContext } from "./context";
import { pluginReducer, initialState } from "./reducer";

// MeshPlugin Provider Component
export const MeshPluginProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [meshData, dispatch] = useReducer(pluginReducer, initialState);

  // Memoize context value to prevent unnecessary re-renders
  const contextValue = useMemo(
    () => ({
      ...meshData,
      dispatch,
    }),
    [meshData],
  );

  return (
    <PluginContext.Provider value={contextValue}>
      {children}
    </PluginContext.Provider>
  );
};
